import { Image } from 'utils'
import { TYPE, canGo, canOnlyGo } from 'network/server_tool'
import { center } from './abstract'
import { KEYS } from 'src/lobby_ui'
import { REQUEST_TYPE } from 'network/net'

export default function( space, container ) {
    space.s( 'slot:showPreFeatureWin' ).to( space.s( 'slot:showWin' ) )
    space.s( 'freegames:showWin' ).to( space.s( 'slot:showWin' ) )
    space.s( 'freegames:showWin' )
        .with( space.s( 'state' ), ( _, state ) => state )
        .to( space.s( 'presenter:regular_win' ) )
    
    //start table:
    const start = Image( 'res/games/freegames/start.png' )
    start.visible = false
    container.addChild( start )
    center( start )
    const steps = new PIXI.extras.BitmapText( '99', { font : 'win_table_nums', align: 'center' } )
    steps.anchor.set( 0.5, 0 )
    steps.position.set( 92, -56 )
    start.addChild( steps )
    space.s( 'presenter:done_playing_wins' )
        .with( space.s( 'state' ), ( _, state ) => state )
        .filter( state => state.type == TYPE.FREESPIN )
        .to( space.s( 'freegames:showComplete' ) )
    
    space.s( 'freegames:noFreeWin' ).to( space.s( 'freegames:showComplete' ) )
    space.s( 'freegames:begin' ).to( space.s( 'freegames:beginComplete' ) )
    
    space.s( 'presenter:done_playing_wins' )
        .with( space.s( 'state' ), ( _, state ) => state )
        .filter( state => state.type == TYPE.REGULAR && canOnlyGo( TYPE.FREESPIN, state ) )
        .name( space, 'freegames:start_table' )
        .on( state => {
            start.visible = true
            steps.text = state.state.stage.math.freeGamesCountIncrease.toString()
        } )
    space.s( 'freegames:start_table' )
        .delay( 0 )
        .to( space.s( 'slot:interruptWinShow' ) )
    space.s( 'ui:start' ).on( () => start.visible = false )
    
    //finish:
    //TODO: proper risk invitation after freegames:
    const finish = Image( 'res/games/freegames/finish.png' )
    finish.visible = false
    container.addChild( finish )
    center( finish )
    const freegames_result = new PIXI.extras.BitmapText( '999', { font : 'win_table_nums', align: 'left' } )
    freegames_result.position.set( 167, 2 )
    finish.addChild( freegames_result )
    space.s( 'state' )
        .filter( state => state.type == TYPE.FINISH )
        .on( state => {
            finish.visible = true
            freegames_result.text = ( state.state.open_win * state.state.multiplier ).toString()
        } )
    space.s( 'keyboard' )
        .filter( k => finish.visible )
        .name( space, 'freegames:finish_choice' )
    space.s( 'pending' ).on( () => finish.visible = false )
    space.s( 'freegames:finish_choice' )
        .filter( k => k == KEYS.BET )
        .map( () => ({ type : REQUEST_TYPE.ENTER_RISK }) )
        .to( space.s( 'request' ) )
    space.s( 'freegames:finish_choice' )
        .filter( k => k == KEYS.START )
        .map( () => ({ type : REQUEST_TYPE.PROCEED }) )
        .to( space.s( 'request' ) )
}





// WEBPACK FOOTER //
// ./src/games/freegames.es6